module.exports = __webpack_public_path__ + "img/dataStatistic.c278d35c.svg";